import { Component, OnInit } from '@angular/core';
import { BirthdayListService } from '../../services/birthday-list.service';

@Component({
  selector: 'app-ponovljeni-rodjendani-report',
  templateUrl: './ponovljeni-rodjendani-report.component.html',
  styleUrls: ['./ponovljeni-rodjendani-report.component.scss'],
})
export class PonovljeniRodjendaniReportComponent implements OnInit {
visitorPagination = {
  currentPage: 1,
  itemsPerPage: 10,
  totalItems: 0
};

 paginationSettings = {
  totalItems: 0,
  itemsPerPage: 2147483647,
  currentPage: 1
};



visitorStats:any[]=[]
loading = false;

 cityQuery: string = ''
  roomNameQuery: string = '';
  birthdayZoneNameQuery: string = '';
  VisitorNameQuery: string = ''; 
  CallDateFromQuery: string = '';
  CallDateToQuery: string = '';
  AppointmentDateFromQuery: string = '';
  AppointmentDateToQuery: string = '';
   PricePerChildrenFromQuery:string=''
      PricePerChildrenToQuery:string='' 
  PlannedChildNumberFromQuery: string = '';
  PlannedChildNumberToQuery: string = '';
  PresentChildNumberQuery: string = '';
  PresentChildNumberFromQuery: string = '';
  PresentChildNumberToQuery: string = '';
  TotalPricePaidQuery: string = '';
  TotalPricePaidFromQuery: string = '';
  TotalPricePaidToQuery: string = '';
  StatusCallQuery: string = '';
  NumberOfBirthdayFromQuery:string=''
  NumberOfBirthdayToQuery:string='';
  AdvancePaymentWillQuery:string='';
  AdvancePricePaidFromQuery:string='';
  AdvancePricePaidToQuery:string='';
  pageSize: number = 2147483647;
  lastVisitorSearch:string=''
  constructor(
private birthdayListService : BirthdayListService

  ) { }

  ngOnInit() {

 this.LoadBirthdayVisitorReport(this.VisitorNameQuery)


  } 

async loadSearchResult() {
    this.birthdayListService.getAllBirthday(
      {
        currentPage: this.paginationSettings.currentPage,
        itemsPerPage: this.paginationSettings.itemsPerPage,
       cityQuery: this.cityQuery,
       roomNameQuery: this.roomNameQuery,
        birthdayZoneNameQuery: this.birthdayZoneNameQuery,
        VisitorNameQuery: this.VisitorNameQuery,       
        CallDateFromQuery: this.CallDateFromQuery,
        CallDateToQuery: this.CallDateToQuery,
        AppointmentDateFromQuery: this.AppointmentDateFromQuery,
        AppointmentDateToQuery: this.AppointmentDateToQuery,      
        PricePerChildrenFromQuery:this. PricePerChildrenFromQuery,   
        PricePerChildrenToQuery: this.PricePerChildrenToQuery, 
        PlannedChildNumberFromQuery: this.PlannedChildNumberFromQuery,
        PlannedChildNumberToQuery: this.PlannedChildNumberToQuery,
        PresentChildNumberFromQuery: this.PresentChildNumberFromQuery,
        PresentChildNumberToQuery: this.PresentChildNumberToQuery,
        TotalPricePaidFromQuery: this.TotalPricePaidFromQuery,
        TotalPricePaidToQuery: this.TotalPricePaidToQuery,
        StatusCallQuery: this.StatusCallQuery,
        NumberOfBirthdayFromQuery:this.NumberOfBirthdayFromQuery,
        NumberOfBirthdayToQuery: this.NumberOfBirthdayToQuery,
        AdvancePaymentWillQuery:this.AdvancePaymentWillQuery,
        AdvancePricePaidFromQuery:this.AdvancePricePaidFromQuery,
        AdvancePricePaidToQuery:this.AdvancePricePaidToQuery
      })  


      console.log ( "Ispred LoadBirthdayVisitorReportLoadBirthdayVisitorReport Visitor query",this.VisitorNameQuery)

      this.lastVisitorSearch=this.VisitorNameQuery

      await this.LoadBirthdayVisitorReport(this.lastVisitorSearch)
    
    }


resetFilters() {
   
    this.VisitorNameQuery = '';  
    this.loadSearchResult() 
 this.LoadBirthdayVisitorReport(this.VisitorNameQuery)

  }

async LoadBirthdayVisitorReport(visitor?: string) {
  this.loading = true;
  this.birthdayListService
    .getReportByVisitors({
      currentPage: this.visitorPagination.currentPage, 
      itemsPerPage: this.visitorPagination.itemsPerPage,
      VisitorNameQuery: visitor
    })
    .subscribe(res => {
      console.log('SERVER RESPONSE', res);

     
      this.visitorStats = res.body ?? [];
      this.loading = false;

      const pag = res.headers?.get('pagination');
      if (pag) {
        const p = JSON.parse(pag);

        this.visitorPagination.totalItems = p.totalItems;
        this.visitorPagination.currentPage = p.currentPage ?? p.curentPage;
        this.visitorPagination.itemsPerPage = p.itemsPerPage;
      }
    });
}

changeVisitorPage(page: number) {
  this.visitorPagination.currentPage = page;
  this.LoadBirthdayVisitorReport(this.lastVisitorSearch);
}
BirthdayVisitorReportExportCSV() {
  this.birthdayListService
    .BirthdayVisitorReportExportCSV({
      currentPage: this.visitorPagination.currentPage,
      itemsPerPage: this.visitorPagination.itemsPerPage,
      pageSize: this.pageSize,
      VisitorNameQuery: this.VisitorNameQuery
    })
    .subscribe(response => {
      this.blobToFile(
        response,
        'text/csv;charset=utf-8;',
        'Zakazivanje po vizitoru.csv'
      );
    });
}

blobToFile(data: any, type: string, fileName: string) {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style.display = 'none';
    const blob = new Blob([data], { type: type });
    const url = window.URL.createObjectURL(blob);
    a.href = url; a.download = fileName; a.click();
    window.URL.revokeObjectURL(url);
  }

}


